import { Reveal } from '../ui/Reveal';
import { Eyebrow, SectionTitle } from '../ui/SectionHeading';
import { howItWorks } from '../../content/site';

export function HowItWorks() {
  return (
    <section
      id="como-funciona"
      className="section-y bg-surface-alt"
      aria-labelledby="como-funciona-titulo"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>{howItWorks.eyebrow}</Eyebrow>
          <SectionTitle className="mt-6 max-w-[900px]">
            <span id="como-funciona-titulo">{howItWorks.title}</span>
          </SectionTitle>
        </Reveal>

        {/* Lista ordenada: el orden de los pasos es información, no estilo, y
            así se transmite a los lectores de pantalla. */}
        <ol className="mt-16 grid gap-10 [grid-template-columns:repeat(auto-fit,minmax(270px,1fr))]">
          {howItWorks.steps.map((step, index) => (
            <Reveal as="li" key={step.number} delay={(index % 4) as 0 | 1 | 2}>
              {/* El número es decorativo: el <ol> ya numera semánticamente, y
                  anunciarlo otra vez daría "uno, uno, Publique la actuación". */}
              <span
                className="block font-display text-[52px] font-extrabold leading-none text-brand/28"
                aria-hidden="true"
              >
                {step.number}
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold text-ink">
                {step.title}
              </h3>
              <p className="mt-3 text-[15px] leading-[1.7] text-ink-muted">
                {step.description}
              </p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
